
let swiper;
window.addEventListener("load", function () {
 
});

let allowScrollTrigger = true;
let touchStartY = 0;

window.addEventListener('touchstart', function (e) {
  touchStartY = e.touches[0].clientY;
});

window.addEventListener('touchend', function (e) {
  const touchEndY = e.changedTouches[0].clientY;
  const deltaY = touchStartY - touchEndY;

  const scrollTop = window.scrollY;
  const windowHeight = window.innerHeight;
  const docHeight = document.documentElement.scrollHeight;

  // Vuốt lên → nếu gần cuối trang thì slideNext
  if (deltaY > 30 && Math.abs(docHeight - (scrollTop + windowHeight)) < 5) {
    swiper.slideNext();
  }

  // Vuốt xuống → nếu gần đầu trang thì slidePrev
  else if (deltaY < -30 && scrollTop < 5) {
    swiper.slidePrev();
  }
});